module.exports = __webpack_public_path__ + "img/fitt.ea9d280b.svg";